export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const FAQS = [
  {
    question: "What is the best time to visit Montreal?",
    answer:
      "The best time to visit Montreal is from March to May or from September to November.",
  },
  {
    question: "How do I get around the city?",
    answer:
      "Montreal offers a great public transit system, including buses and metro trains. Taxis and Uber are also available.",
  },
  {
    question: "What local dishes should I try?",
    answer:
      "Try Montreal's famous poutine, smoked meat sandwiches, and bagels.",
  },
  {
    question: "Where can I find the best bagels?",
    answer: "St-Viateur and Fairmount Bagel are top spots for Montreal bagels.",
  },
  {
    question: "Are there any free attractions in Montreal?",
    answer:
      "Yes, Mount Royal Park, Old Montreal, and the Lachine Canal are great free attractions.",
  },
];
